import { Link } from "react-router-dom";
import "./FooterBottom.scss";

const FooterBottom = () => {
  return (
    <>
      <div class="row mt-4">
        <div class="col-12 footer-bottom-links">
          <Link to="/terms-condition">Terms of Service</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
      <p
        style={{
          backgroundColor: "#abb8ae",
          color: "#abb8ae",
          position: "absolute",
          left: "-99999px",
          top: "auto",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
      >
        Kuwait Pack © 2025. All rights reserved | Designed by{" "}
        <a
          target="_blank"
          href="https://www.tomsher.com/"
          style={{
            color: "#abb8ae",
          }}
        >
          Tomsher
        </a>
      </p>
    </>
  );
};

export default FooterBottom;
